import {
    Grid,
    GridProps,
} from '@chakra-ui/react';
import { CateringFormatModel } from 'entities';
import React from 'react';
import { GridCard } from 'shared';

export type CateringPageMainTabsCateringFormatsContentProps = {
    cateringFormats: CateringFormatModel[],
} & GridProps & React.RefAttributes<HTMLDivElement>

export const CateringPageMainTabsCateringFormatsContent
: React.FC<CateringPageMainTabsCateringFormatsContentProps> = ({
    cateringFormats,
}) => (
    <Grid
        gap="2rem"
        templateColumns={{
            base: '1fr 1fr',
            lg: '1fr 1fr 1fr 1fr',
        }}
    >
        {cateringFormats.map(({ slug, name, images }) => (
            <GridCard
                flex="1 0 21%"
                aspectRatio="2 / 3"
                label={name}
                to={`/catering/formats/${slug}`}
                src={images?.at(0)?.url}
            />
        ))}
    </Grid>
);
